import React, { Component } from 'react'
import { Button, Typography } from '@material-ui/core';
import View from 'react-flexbox'
import AddIcon from '@material-ui/icons/Add';
import { TabelaScorpion, ItemCustomRender, DialogPesquisa } from 'scorpion-core';
import DinamicCrudCustomPesquisa from '../../../../DinamicForms/components/DinamicCrudCustomPesquisa';


import produce from "immer"


export default class Tabela extends Component {
    constructor(props) {
        super(props)
        this.updateItem = this.updateItem.bind(this)
        this.addItem = this.addItem.bind(this)
        this.state = { editar: {} }

    }
    componentDidMount() {


    }
    updateItem(item) {


        const { input: { value, onChange } } = this.props
        let data = [];
        if (value) {
            data = value.slice();
        }
        const { index } = item;

        if (index != null) {

            data[index] = item;
        } else {
            data.push(item);

        }

        onChange(data)
    }

    getRenderCell(comp, item, indexArray) {
        const { customFormInterno, propsview } = this.props
        if (!comp.desativado) {
            let compExibir = getCompNoCuston(customFormInterno, comp.field);
            if (compExibir) {
                return <ItemCustomRender
                    item={{ ...compExibir, field: item.field + "." + indexArray + "." + comp.field, label: undefined }}
                    propsadd={{ style: {} }}
                    propsview={propsview}
                />
            }
        }

        return <ItemCustomRender
            item={{ ...comp, field: item.field + "." + indexArray + "." + comp.field, label: undefined }}
            propsadd={{ style: {} }}
            propsview={propsview}
        />

    }

    addItem(item) {
        const { input: { value, onChange } } = this.props
        const nextState = produce(value || [], draftState => {
            draftState.push(item);

        })

        onChange(nextState);

    }

    render() {
        const { item, input: { value, onChange }, propsview, customFormInterno } = this.props
        let mensagemVazio = "Sem Itens"
        let colunas = [];

        item.componentes.forEach((comp, index) => {
            colunas.push({
                ...comp, getValue: (itemArray, indexArray) => (
                    this.getRenderCell(comp, item, indexArray))
            })
        });


        let data = [];
        if (value) {
            data = value
        }
        let pesquisa = null;
        let telaPesquisaInjetada = null;
        if (customFormInterno && customFormInterno.componenteRoot) {

            pesquisa = <DinamicCrudCustomPesquisa componentes={customFormInterno.componenteRoot.componentes.slice()} customFormUid={customFormInterno.uid} titulo={"Pesquisa de " + customFormInterno.nomeForm} global={customFormInterno.global} />


            telaPesquisaInjetada = React.cloneElement(pesquisa, {
                selecionar: (item) => {
                    this.addItem(item)
                    this.dialog.hide();
                }
            })
        }

        return <View column>
            <View>
                <Typography variant="h6" >{item.label}</Typography>
                {item.customFormUid && <Button variant="contained" color="primary" onClick={() => {

                    this.dialog.show()


                }}> <AddIcon />Adicionar</Button>}
            </View>
            <div >
                <TabelaScorpion colunas={colunas} mensagemVazio={mensagemVazio} data={data} />
            </div>
            <div>
                {telaPesquisaInjetada && <DialogPesquisa forwardedRef={node => this.dialog = node} > {telaPesquisaInjetada}</DialogPesquisa>}


            </div>
        </View>

    }

}



export function getCompNoCuston(customForm, field) {
    return getCompNoCustom(customForm.componenteRoot.componentes, field);

}


export function getCompNoCustom(componentes, field) {
    let retorno = null;
    componentes.forEach(element => {
        // console.log('element',element);

        if (element.field === field) {
            retorno = element;
        }
        if (element.componentes && !retorno) {
            let r = getCompNoCustom(element.componentes, field)
            if (r) {
                retorno = r;
            }
        }
    });
    return retorno;
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/PesquisaItensCustomForm/Tabela/Tabela.js